/* Little Sonny theme — product page: variants, gallery, lightbox, sticky bar, waitlist */
(function () {
  'use strict';

  var LS = window.LittleSonny || {};
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var quantity = 1;
  var currentVariantId = null;
  var currentVariantTitle = '';

  /* ------------------------------------------------------------ quantity */
  function paintQuantity() {
    document.querySelectorAll('[data-qty-value]').forEach(function (el) {
      el.textContent = quantity;
    });
  }
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    quantity = Math.max(1, quantity + Number(step.dataset.qtyStep));
    paintQuantity();
  });

  /* ------------------------------------------------------------- variants */
  var variantButtons = Array.prototype.slice.call(document.querySelectorAll('[data-variant-button]'));
  var mainImage = document.querySelector('[data-gallery-main]');

  function selectVariant(button) {
    currentVariantId = button.dataset.variantId;
    currentVariantTitle = button.dataset.variantTitle;
    var available = button.dataset.variantAvailable === 'true';

    variantButtons.forEach(function (other) {
      var active = other === button;
      other.setAttribute('aria-pressed', active ? 'true' : 'false');
      other.classList.toggle('border-black', active);
      other.classList.toggle('border-transparent', !active);
    });

    document.querySelectorAll('[data-product-price]').forEach(function (el) {
      el.textContent = button.dataset.variantPrice;
    });
    document.querySelectorAll('span[data-variant-title]').forEach(function (el) {
      el.textContent = currentVariantTitle;
    });
    document.querySelectorAll('[data-waitlist-variant]').forEach(function (el) {
      el.textContent = currentVariantTitle;
    });

    var soldOut = document.querySelector('[data-sold-out-label]');
    if (soldOut) soldOut.classList.toggle('hidden', available);
    var purchase = document.querySelector('[data-purchase-block]');
    if (purchase) purchase.classList.toggle('hidden', !available);
    var waitlist = document.querySelector('[data-waitlist-block]');
    if (waitlist) waitlist.classList.toggle('hidden', available);
    var stickyQty = document.querySelector('[data-sticky-qty]');
    if (stickyQty) stickyQty.classList.toggle('hidden', !available);
    document.querySelectorAll('[data-add-label]').forEach(function (el) {
      el.textContent = available ? 'Add to Basket' : 'Join the Waitlist';
    });

    if (available && button.dataset.variantImage && mainImage) {
      mainImage.src = button.dataset.variantImage;
    }

    // Keep the URL shareable, like a normal Shopify product page
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', currentVariantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  variantButtons.forEach(function (button) {
    button.addEventListener('click', function () { selectVariant(button); });
    if (button.getAttribute('aria-pressed') === 'true') {
      currentVariantId = button.dataset.variantId;
      currentVariantTitle = button.dataset.variantTitle;
    }
  });

  if (!currentVariantId) {
    try {
      var data = JSON.parse(root.dataset.productJson);
      var first = data.variants.find(function (v) { return v.available; }) || data.variants[0];
      currentVariantId = first.id;
      currentVariantTitle = first.title;
    } catch (error) { /* leave unset */ }
  }

  /* --------------------------------------------------------- add to cart */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-to-cart]');
    if (!button) return;
    var label = button.querySelector('[data-add-label]');
    if (label && label.textContent.indexOf('Waitlist') !== -1) {
      var target = document.getElementById('waitlist-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    button.disabled = true;
    LS.addToCart(currentVariantId, quantity)
      .catch(function () {})
      .then(function () { button.disabled = false; });
  });

  /* -------------------------------------------------------------- gallery */
  var images = [];
  var imagesTag = document.querySelector('[data-gallery-images]');
  if (imagesTag) {
    try { images = JSON.parse(imagesTag.textContent); } catch (error) { images = []; }
  }
  var active = 0;

  var thumbsDesktop = document.querySelectorAll('[data-gallery-select]');
  thumbsDesktop.forEach(function (thumb) {
    function pick() {
      active = Number(thumb.dataset.index);
      if (mainImage) mainImage.src = thumb.dataset.full;
      thumbsDesktop.forEach(function (other) {
        var on = other === thumb;
        other.classList.toggle('border-foreground', on);
        other.classList.toggle('border-transparent', !on);
      });
    }
    thumb.addEventListener('mouseenter', pick);
    thumb.addEventListener('click', pick);
  });

  var track = document.querySelector('[data-gallery-track]');
  var mobileThumbs = document.querySelectorAll('[data-gallery-thumb]');
  function goMobile(index) {
    if (!track) return;
    var count = track.children.length;
    active = (index + count) % count;
    track.scrollTo({ left: active * track.clientWidth, behavior: 'smooth' });
    mobileThumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('border-foreground', i === active);
      thumb.classList.toggle('border-transparent', i !== active);
    });
  }
  if (track) {
    track.addEventListener('scroll', function () {
      active = Math.round(track.scrollLeft / track.clientWidth);
    });
  }
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { goMobile(active - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goMobile(active + 1); });
  mobileThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { goMobile(Number(thumb.dataset.index)); });
  });

  /* ------------------------------------------------------------ lightbox */
  var lightbox = document.querySelector('[data-lightbox]');
  var lightboxImage = document.querySelector('[data-lightbox-image]');
  var counter = document.querySelector('[data-lightbox-counter]');

  function paintLightbox() {
    if (!images.length || !lightboxImage) return;
    active = (active + images.length) % images.length;
    lightboxImage.src = images[active].url;
    lightboxImage.alt = images[active].alt;
    if (counter) counter.textContent = active + 1 + ' / ' + images.length;
  }
  function openLightbox(index) {
    if (!lightbox) return;
    if (typeof index === 'number') active = index;
    paintLightbox();
    lightbox.classList.remove('hidden');
    lightbox.classList.add('flex');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.add('hidden');
    lightbox.classList.remove('flex');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-lightbox-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var index = button.dataset.index ? Number(button.dataset.index) : active;
      openLightbox(index);
    });
  });
  var lbClose = document.querySelector('[data-lightbox-close]');
  var lbPrev = document.querySelector('[data-lightbox-prev]');
  var lbNext = document.querySelector('[data-lightbox-next]');
  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev) lbPrev.addEventListener('click', function () { active -= 1; paintLightbox(); });
  if (lbNext) lbNext.addEventListener('click', function () { active += 1; paintLightbox(); });
  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (event) {
    if (!lightbox || lightbox.classList.contains('hidden')) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowRight') { active += 1; paintLightbox(); }
    if (event.key === 'ArrowLeft') { active -= 1; paintLightbox(); }
  });

  /* ----------------------------------------------------------- sticky bar */
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var galleryAnchor = document.querySelector('[data-gallery-anchor]');
  if (stickyBar && galleryAnchor) {
    var onScroll = function () {
      var show = galleryAnchor.getBoundingClientRect().top < 0;
      stickyBar.classList.toggle('translate-y-full', !show);
      stickyBar.classList.toggle('translate-y-0', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ------------------------------------------------------------- waitlist */
  var waitlistForm = document.querySelector('[data-waitlist-form]');
  if (waitlistForm) {
    waitlistForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(waitlistForm);
      var country = String(data.get('dial') || 'GB|+44').split('|');
      var button = waitlistForm.querySelector('button[type="submit"]');
      var label = waitlistForm.querySelector('[data-submit-label]');
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding you…';

      fetch(LS.functionsUrl.replace('/functions/v1', '') + '/rest/v1/waitlist_signups', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: LS.anonKey,
          Authorization: 'Bearer ' + LS.anonKey,
          Prefer: 'return=minimal'
        },
        body: JSON.stringify({
          first_name: data.get('firstName'),
          last_name: data.get('lastName'),
          email: data.get('email'),
          country_code: country[0],
          dial_code: country[1],
          phone: String(data.get('phone') || '').replace(/[\s-]/g, ''),
          product_handle: root.dataset.productHandle || '',
          product_title: document.querySelector('h1') ? document.querySelector('h1').textContent : '',
          variant_id: currentVariantId,
          variant_title: currentVariantTitle
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('failed');
          waitlistForm.classList.add('hidden');
          var success = document.querySelector('[data-waitlist-success]');
          if (success) success.classList.remove('hidden');
        })
        .catch(function () {
          if (LS.toast) LS.toast('Something went wrong', 'Please try again in a moment.');
        })
        .then(function () {
          if (button) button.disabled = false;
          if (label) label.textContent = 'Notify Me';
        });
    });
  }

  paintQuantity();
})();
